<div class="HeaderBasket">
    <div class="HeaderBasket_Btn uk-height-1-1">
		<span class="IconItem IconItem--basket">
			<img src="/assets/img/icon/basket.svg" uk-svg>
		</span>
		<span>{{totalQuantity}}</span>
	</div>
    <div class="HeaderBasket_Menu uk-dropdown" id="HeaderBasket_Menu">
        <div class="uk-overflow-auto" *ngIf="cartService.cart && cartService.cart.ITEMS.length > 0">
            <table class="uk-table">
                <tbody>
                    <tr *ngFor="let item of cartService.cart.ITEMS">
                        <td class="uk-text-truncate">
							<a [routerLink]="item.PROVIDER_DATA.DETAIL_PAGE_URL">{{item.PROVIDER_DATA.NAME}}</a>
						</td>
                        <td class="uk-text-right uk-text-nowrap">{{ item.QUANTITY + ' шт' }}</td>
                        <td class="uk-text-right uk-text-nowrap uk-position-relative">
							<span><span *ngIf="item.PRICE_ARR.QUANTITY_FROM">от </span>{{ (item.PRICE * item.QUANTITY) | currency:item.PROVIDER_DATA.CURRENCY:'symbol':'1.0-0' }}</span>
							<span class="IconItem IconItem--close uk-position-center-right" title="Удалить из корзины" (click)="deleteFromCart(item.OFFER_ID)">
								<img src="/assets/img/icon/close.svg" uk-svg>
							</span>
						</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="uk-flex uk-flex-middle uk-flex-between uk-margin-small-top" *ngIf="cartService.cart && cartService.cart.ITEMS.length > 0">
			<span><strong>Итого: {{ cartService.cart.BASKET_PRICE | currency:totalCurrency:'symbol':'1.0-0' }}</strong></span>
			<a class="uk-button uk-button-primary" routerLink="/cart">Оформить заказ</a>
		</div>
        <div *ngIf="!cartService.cart" class="uk-margin-top">Ваша корзина пуста</div>
    </div>
</div>
